"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var rc_tree_1 = require("rc-tree");
var core_1 = require("@material-ui/core");
var Icon_1 = require("./Icon");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var styles_1 = require("@material-ui/core/styles");
var react_1 = require("react");
var LOAD_MORE = 'loadMore';
var LOAD_MORE_CLASS = 'rc-tree-treenode-load-more';
var useSelectTreeStyles = styles_1.makeStyles(function (theme) {
    var _a;
    return ({
        root: {
            position: 'relative',
            '& .rc-tree': {
                '& .rc-tree-treenode': (_a = {
                        display: 'flex',
                        margin: '0.5rem',
                        marginBottom: '0.25rem',
                        outline: 'none',
                        userSelect: 'none'
                    },
                    _a["&." + LOAD_MORE_CLASS] = {
                        margin: 0,
                    },
                    _a['& .rc-tree-indent'] = {
                        display: 'flex',
                    },
                    _a['& .rc-tree-indent-unit'] = {
                        display: 'block',
                        width: '1.5rem',
                    },
                    _a['& .rc-tree-switcher_close, & .rc-tree-switcher_open'] = {
                        width: '1rem',
                        display: 'flex',
                        alignItems: 'center',
                    },
                    _a['& .rc-tree-switcher-noop'] = {
                        width: '1rem',
                    },
                    _a['& .rc-tree-node-content-wrapper'] = {
                        display: 'flex',
                    },
                    _a['& .rc-tree-title'] = {
                        fontFamily: 'Roboto',
                        marginLeft: '.3rem',
                        paddingTop: '.125rem',
                    },
                    _a),
            },
        },
        treeContainer: function (props) { return ({
            position: 'absolute',
            zIndex: 2,
            maxHeight: props.maxHeight || '15rem',
            overflowX: 'hidden',
            overflowY: 'auto',
            width: '100%',
            marginTop: '0.3rem',
            padding: 0,
        }); },
        checkbox: {
            padding: 0,
        },
    });
});
var SelectTree = function (_a) {
    var label = _a.label, required = _a.required, icon = _a.icon, placeholder = _a.placeholder, onCheck = _a.onCheck, onSelect = _a.onSelect, onFilterChange = _a.onFilterChange, _b = _a.filter, filter = _b === void 0 ? '' : _b, treeData = _a.treeData, loadMoreData = _a.loadMoreData, _c = _a.checkable, checkable = _c === void 0 ? true : _c, clickedNode = _a.selectedNode, restProps = __rest(_a, ["label", "required", "icon", "placeholder", "onCheck", "onSelect", "onFilterChange", "filter", "treeData", "loadMoreData", "checkable", "selectedNode"]);
    var classes = useSelectTreeStyles(restProps);
    var treeContainerRef = react_1.useRef(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var checkedParents = react_1.useMemo(function () { return restProps.checkedKeys && getCheckedParents(restProps.checkedKeys, treeData || []); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [restProps.checkedKeys && restProps.checkedKeys.toString(), treeData]);
    var _d = __read(react_1.useState(false), 2), textFieldFocussed = _d[0], setTextFieldFocussed = _d[1];
    var _e = __read(react_1.useState(false), 2), treeVisible = _e[0], setTreeVisible = _e[1];
    var _f = __read(react_1.useState([]), 2), expandedKeys = _f[0], setExpandedKeys = _f[1];
    react_1.useEffect(function () {
        document.addEventListener('mousedown', handleClick);
        return function () {
            document.removeEventListener('mousedown', handleClick);
        };
    });
    function handleClick(event) {
        var node = treeContainerRef.current;
        if (node && !node.contains(event.target)) {
            // Hide dropdown if the click if outside of the dropdown
            setTreeVisible(false);
        }
    }
    function getSelected() {
        if (!checkable || !checkedParents) {
            return clickedNode ? clickedNode.title : '';
        }
        var titles = checkedParents.map(function (node) { return (node.title ? node.title.toString() : ''); });
        return titles.length > 5 ? titles.slice(0, 5).join(', ') + '...' || '' : titles.join(', ') || '';
    }
    return (React.createElement("div", { className: classes.root, ref: treeContainerRef },
        React.createElement(core_1.TextField, { value: textFieldFocussed ? filter : getSelected(), placeholder: placeholder, label: label, required: required, onChange: function (event) { return onFilterChange && onFilterChange(event.target.value); }, onFocus: function () {
                setTreeVisible(true);
                setTextFieldFocussed(true);
            }, onBlur: function () { return setTextFieldFocussed(false); }, fullWidth: true, variant: "outlined", InputProps: {
                endAdornment: (React.createElement(core_1.InputAdornment, { position: "end" },
                    React.createElement(Icon_1.default, { icon: pro_solid_svg_icons_1.faCaretDown }))),
            }, margin: "dense" }),
        React.createElement(core_1.Paper, { elevation: 1, className: classes.treeContainer, style: {
                display: treeVisible ? 'flex' : 'none',
            } },
            React.createElement(rc_tree_1.default, __assign({ checkable: checkable, selectable: false, onCheck: function (checkedKeys) {
                    if (!treeData)
                        return;
                    var checkedParents = getCheckedParents(checkedKeys, treeData);
                    var checked = checkedKeys.map(function (key) { return findTreeNode(key, treeData); });
                    if (onCheck) {
                        onCheck(checkedKeys, checked, checkedParents);
                    }
                }, switcherIcon: function (props) {
                    return (!props.isLeaf && React.createElement(Icon_1.default, { icon: props.loading ? pro_light_svg_icons_1.faSpinner : props.expanded ? pro_solid_svg_icons_1.faCaretDown : pro_solid_svg_icons_1.faCaretRight }));
                }, icon: function (props) {
                    return checkable &&
                        props.checkable !== false && (React.createElement(core_1.Checkbox, { className: classes.checkbox, checked: props.checked, indeterminate: props.halfChecked, onChange: function () { return null; } }));
                }, treeData: treeData, onClick: function (e, node) {
                    if (node.key.toString().includes(LOAD_MORE) && loadMoreData && treeData) {
                        loadMoreData(findParentTreeNode(node.key, treeData));
                    }
                    else if (!checkable && onSelect) {
                        if (node.selectable) {
                            onSelect(node);
                            setTreeVisible(false);
                        }
                        else {
                            var key = node.key.toString();
                            if (expandedKeys.includes(key)) {
                                expandedKeys.splice(expandedKeys.indexOf(key), 1);
                                setExpandedKeys(__spread(expandedKeys));
                            }
                            else {
                                setExpandedKeys(__spread(expandedKeys, [key]));
                            }
                        }
                    }
                }, expandedKeys: expandedKeys, onExpand: setExpandedKeys }, restProps)))));
};
function getAllChildren(node, includeCurrent) {
    if (includeCurrent === void 0) { includeCurrent = false; }
    var current = includeCurrent ? [node] : [];
    if (node.children) {
        return node.children.reduce(function (arr, _) { return __spread(arr, getAllChildren(_, true)); }, current);
    }
    return current;
}
function getCheckedParents(checkedKeys, treeData) {
    var checkedChildrenKeys = checkedKeys.reduce(function (acc, key) {
        var node = findTreeNode(key, treeData);
        if (!node) {
            throw new Error("Cannot find node in tree data with key '" + key + "'");
        }
        acc.push.apply(acc, __spread(getAllChildren(node).map(function (_) { return _.key; })));
        return acc;
    }, []);
    return checkedKeys.filter(function (key) { return !checkedChildrenKeys.includes(key); }).map(function (key) { return findTreeNode(key, treeData); });
}
function findTreeNode(key, treeData) {
    var e_1, _a;
    try {
        for (var treeData_1 = __values(treeData), treeData_1_1 = treeData_1.next(); !treeData_1_1.done; treeData_1_1 = treeData_1.next()) {
            var node = treeData_1_1.value;
            if (node.key === key) {
                return node;
            }
            if (node.children) {
                var childNode = findTreeNode(key, node.children);
                if (childNode) {
                    return childNode;
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (treeData_1_1 && !treeData_1_1.done && (_a = treeData_1.return)) _a.call(treeData_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return;
}
function findParentTreeNode(key, treeData) {
    var e_2, _a, e_3, _b;
    try {
        for (var treeData_2 = __values(treeData), treeData_2_1 = treeData_2.next(); !treeData_2_1.done; treeData_2_1 = treeData_2.next()) {
            var node = treeData_2_1.value;
            if (node.children) {
                try {
                    for (var _c = (e_3 = void 0, __values(node.children)), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var childNode_1 = _d.value;
                        if (childNode_1.key === key) {
                            return node;
                        }
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                var childNode = findParentTreeNode(key, node.children);
                if (childNode) {
                    return childNode;
                }
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (treeData_2_1 && !treeData_2_1.done && (_a = treeData_2.return)) _a.call(treeData_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return;
}
var useLoadMoreButtonStyles = styles_1.makeStyles({
    icon: {
        verticalAlign: '1rem',
    },
    iconContainer: {
        height: '1rem',
        marginLeft: '.25rem',
    },
});
var LoadMoreButton = function () {
    var _a = __read(react_1.useState(false), 2), loading = _a[0], setLoading = _a[1];
    var classes = useLoadMoreButtonStyles();
    return (React.createElement(core_1.Button, { color: "primary", onClick: function () { return setLoading(true); }, startIcon: React.createElement(Icon_1.default, { icon: loading ? pro_light_svg_icons_1.faSpinner : pro_light_svg_icons_1.faPlus, color: "primary", className: classes.iconContainer, iconClassName: classes.icon }) }, "Show more"));
};
var loadMoreCount = 0;
function getLoadMoreNode() {
    return {
        key: LOAD_MORE + loadMoreCount++,
        title: React.createElement(LoadMoreButton, null),
        isLeaf: true,
        checkable: false,
        selectable: false,
        className: LOAD_MORE_CLASS,
    };
}
exports.getLoadMoreNode = getLoadMoreNode;
exports.default = SelectTree;
//# sourceMappingURL=SelectTree.js.map